import { createRoutine } from "redux-saga-routines";

export const anamnezRoutine = createRoutine("API_ANAMNEZ_GET");
export const anamnezLifeRoutine = createRoutine("API_ANAMNEZ_LIFE_GET");
export const anamnezDiagnozRoutine = createRoutine("API_ANAMNEZ_DIAGNOZ_GET");
export const userAnamnezRoutine = createRoutine("API_USER_ANAMNEZ_SAVE");
